"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagsComponent = void 0;

var RegionComponent_1 = require("./RegionComponent");
/**
 * An abstract visual component used internall do draw tags data for regions.
 */


var TagsComponent = /*#__PURE__*/function (_RegionComponent_1$Re) {
  _inherits(TagsComponent, _RegionComponent_1$Re);

  /**
   * Creates a new `TagsComponent` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param tags - The `TagsDescriptor` object presenting colors and names for region tags.
   * @param styleId - The unique css style id for region.
   * @param styleSheet - The regerence to the stylesheet object for rules insection.
   * @param tagsUpdateOptions - The settings for redrawing tags.
   */
  function TagsComponent(paper, paperRect, regionData, tags, styleId, styleSheet, tagsUpdateOptions) {
    var _this;

    _classCallCheck(this, TagsComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TagsComponent).call(this, paper, paperRect, regionData, null));
    /**
     * Reference to the stylesheet element.
     */

    _this.styleSheet = null;
    /**
     * Default styling rules.
     */

    _this.styleMap = [];
    /**
     * Light styling rules used when `showRegionBackground` is set to `false`.
     */

    _this.styleLightMap = [];
    _this.styleId = styleId;
    _this.styleSheet = styleSheet;
    _this.tags = tags;
    _this.tagsUpdateOptions = tagsUpdateOptions;
    _this.node = paper.g();

    _this.node.addClass("tagsLayer");

    return _this;
  }
  /**
   * Updates component with new `TagsDescriptor` object and new drawing settings.
   * @param tags - The new `TagsDescriptor` object.
   * @param options - The new drawing settings.
   */


  _createClass(TagsComponent, [{
    key: "updateTags",
    value: function updateTags(tags, options) {
      this.tags = tags;
      this.tagsUpdateOptions = options;
      this.rebuildTagLabels();
      this.clearStyleMaps();
      this.initStyleMaps(tags);
      var showBackground = options !== undefined ? options.showRegionBackground : true;
      this.applyStyleMaps(showBackground);
    }
    /**
     * Clears current styling rules.
     */

  }, {
    key: "clearStyleMaps",
    value: function clearStyleMaps() {
      while (this.styleSheet.cssRules.length > 0) {
        this.styleSheet.deleteRule(0);
      }
    }
    /**
     * Inserts the styling rules into the `styleSheet` object.
     * @param showRegionBackground - The flag to make background visible or transparent.
     */

  }, {
    key: "applyStyleMaps",
    value: function applyStyleMaps() {
      var _this2 = this;

      var showRegionBackground = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      // Map primary tag color
      if (this.tags && this.tags.primary !== undefined) {
        window.requestAnimationFrame(function () {
          var sm = showRegionBackground ? _this2.styleMap : _this2.styleLightMap;

          var _iterator = _createForOfIteratorHelper(sm),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var r = _step.value;

              _this2.styleSheet.insertRule("".concat(r.rule, "{").concat(r.style, "}"), 0);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
      }
    }
  }]);

  return TagsComponent;
}(RegionComponent_1.RegionComponent);

exports.TagsComponent = TagsComponent;